import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@progress/kendo-react-common';
import { chevronRightIcon, exclamationCircleIcon, warningTriangleIcon } from '@progress/kendo-svg-icons';
import { DlpIssue } from 'utils/dlpConfigurationValidation';
import { IssueBadges } from './IssueBadges';

interface IssueListProps {
    issues: DlpIssue[];
}

export function IssueList({ issues }: IssueListProps) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    if (!issues.length) return null;

    return (
        <div className="issue-collapsible">
            <button type="button" className="issue-summary-bar" onClick={() => setOpen(o => !o)}>
                <div className="issue-summary-left"><IssueBadges issues={issues} /></div>
                <SvgIcon icon={chevronRightIcon} className={`chevron ${open ? 'rotate-90' : ''}`} />
            </button>
            {open && (
                <div className="issue-list">
                    {issues.map(issue => (
                        <div key={issue.id} className={`issue-row ${issue.severity}`}>
                            <SvgIcon icon={issue.severity === 'error' ? exclamationCircleIcon : warningTriangleIcon} size="small" />
                            <div>
                                <div className="issue-rule">{issue.rule}</div>
                                <div>{t(`dlpConfiguration.rules.${issue.messageKey}`, issue.params)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
